// /**
//  * Featured collection + banner slider (Flickity).
//  * Mirrors the theme's Flickity usage patterns (see customer-love-it.js) but for product cards.
//  */
// (function () {
//   'use strict';

//   function getFlkty(el) {
//     if (typeof Flickity === 'undefined' || !el) return null;
//     return Flickity.data(el);
//   }

//   function getGroupCells(slider) {
//     var desktop = parseFloat(slider.dataset.slidesDesktop) || 3;
//     var tablet = parseFloat(slider.dataset.slidesTablet) || 2;
//     var mobile = parseFloat(slider.dataset.slidesMobile) || 1;
//     if (window.innerWidth > 1024) return desktop;
//     if (window.innerWidth >= 768) return tablet;
//     return mobile;
//   }

//   function initOne(section) {
//     if (!section || section.dataset.fcbsInit === 'true') return;
//     var slider = section.querySelector('[data-fcbs-slider]');
//     if (!slider) return;
//     if (typeof Flickity === 'undefined') return;

//     section.dataset.fcbsInit = 'true';

//     var nav = slider.dataset.showNav === 'true';
//     var totalSlides = slider.querySelectorAll('.carousel-cell').length;

//     function getOptions() {
//       var slidesToShow = getGroupCells(slider);
//       var containV = totalSlides <= slidesToShow;
//       var wrapV = totalSlides > slidesToShow;
//       var trueNav = Boolean(nav && wrapV);
//       return {
//         cellAlign: 'left',
//         contain: containV,
//         imagesLoaded: true,
//         wrapAround: wrapV,
//         autoPlay: false,
//         prevNextButtons: trueNav,
//         pageDots: false,
//         draggable: wrapV,
//         touchVerticalScroll: false,
//         adaptiveHeight: false,
//         percentPosition: true,
//       };
//     }

//     var flkty = new Flickity(slider, getOptions());
//     var lastSlidesToShow = getGroupCells(slider);

//     function onResize() {
//       var newSlides = getGroupCells(slider);
//       if (newSlides !== lastSlidesToShow) {
//         flkty.destroy();
//         flkty = new Flickity(slider, getOptions());
//         lastSlidesToShow = newSlides;
//       } else {
//         flkty.resize();
//       }
//     }

//     var debounced =
//       typeof theme !== 'undefined' &&
//       theme.utils &&
//       typeof theme.utils.debounce === 'function'
//         ? theme.utils.debounce(300, onResize)
//         : (function () {
//             var t;
//             return function () {
//               clearTimeout(t);
//               t = setTimeout(onResize, 300);
//             };
//           })();

//     window.addEventListener('resize', debounced);

//     // If theme code already initialized Flickity on this node, prefer that instance.
//     // (Defensive: Shopify editor can re-render.)
//     var existing = getFlkty(slider);
//     if (existing && existing !== flkty) {
//       try {
//         flkty.destroy();
//       } catch (e) {}
//     }
//   }

//   function boot() {
//     document
//       .querySelectorAll('[data-section-type="featured-collection-banner-slider"]')
//       .forEach(initOne);
//   }

//   function onSectionLoad(e) {
//     if (!e.target || !e.target.querySelectorAll) return;
//     e.target
//       .querySelectorAll('[data-section-type="featured-collection-banner-slider"]')
//       .forEach(initOne);
//   }

//   if (!window.__fcbsListeners) {
//     window.__fcbsListeners = true;
//     document.addEventListener('page:loaded', boot);
//     document.addEventListener('shopify:section:load', onSectionLoad);
//   }

//   if (typeof Flickity !== 'undefined') {
//     boot();
//   } else {
//     document.addEventListener('DOMContentLoaded', boot);
//   }
// })();

/**
 * Featured collection + banner slider (Flickity).
 * Mirrors the theme's Flickity usage patterns (see customer-love-it.js) but for product cards.
 */
(function () {
  'use strict';

  function getFlkty(el) {
    if (typeof Flickity === 'undefined' || !el) return null;
    return Flickity.data(el);
  }

  function getGroupCells(slider) {
    var desktop = parseFloat(slider.dataset.slidesDesktop) || 3;
    var tablet = parseFloat(slider.dataset.slidesTablet) || 2;
    var mobile = parseFloat(slider.dataset.slidesMobile) || 1;
    if (window.innerWidth > 1024) return desktop;
    if (window.innerWidth >= 768) return tablet;
    return mobile;
  }

  function bindScrollbar(section, slider, flkty) {
    var container = section.querySelector('.recs-inline');
    if (!container || !flkty) return null;

    var scrollbar = container.querySelector('.recs-inline__scrollbar');
    if (!scrollbar) return null;

    var state = section._fcbsScrollbar;
    if (!state) {
      state = { flkty: flkty };
      section._fcbsScrollbar = state;

      function getFlkty() {
        return state.flkty;
      }

      function thumbMetrics() {
        var instance = getFlkty();
        var barW = scrollbar.clientWidth;
        var viewport = instance.size.innerWidth;
        var total = viewport + instance.slideableWidth;
        var ratio = total > 0 ? viewport / total : 1;
        var thumbW = Math.round(barW * ratio);
        thumbW = Math.max(thumbW, 24);
        if (thumbW >= barW) thumbW = Math.max(barW - 2, 8);
        var maxThumbX = Math.max(barW - thumbW, 0);
        return { thumbW: thumbW, maxThumbX: maxThumbX };
      }

      state.update = function updateScrollbar() {
        var instance = getFlkty();
        var maxScroll = instance.slideableWidth;
        var scrollNorm = -instance.x;
        var canScroll = maxScroll > 1;

        scrollbar.classList.toggle('has-overflow', canScroll);

        if (!canScroll) {
          scrollbar.style.removeProperty('--thumb-w');
          scrollbar.style.removeProperty('--thumb-x');
          return;
        }

        var m = thumbMetrics();
        var frac = maxScroll > 0 ? Math.max(0, Math.min(1, scrollNorm / maxScroll)) : 0;
        var thumbX = m.maxThumbX * frac;
        scrollbar.style.setProperty('--thumb-w', m.thumbW + 'px');
        scrollbar.style.setProperty('--thumb-x', thumbX + 'px');
      };

      function onScrollbarDragStart(e) {
        e.preventDefault();
        var instance = getFlkty();
        var m = thumbMetrics();
        var startX = e.clientX;
        var startScroll = -instance.x;
        var maxScroll = instance.slideableWidth;
        var maxThumbX = m.maxThumbX;
        if (maxThumbX <= 0 || maxScroll <= 0) return;

        function onMouseMove(moveEvent) {
          var deltaX = moveEvent.clientX - startX;
          var scrollDelta = (deltaX / maxThumbX) * maxScroll;
          instance.x = -(startScroll + scrollDelta);
          instance.positionSlider();
          if (instance.settle) instance.settle();
          state.update();
        }

        function onMouseUp() {
          document.removeEventListener('mousemove', onMouseMove);
          document.removeEventListener('mouseup', onMouseUp);
        }

        document.addEventListener('mousemove', onMouseMove);
        document.addEventListener('mouseup', onMouseUp);
      }

      state.onScroll = state.update;
      scrollbar.addEventListener('mousedown', onScrollbarDragStart);
      window.addEventListener('resize', state.update);

      if (typeof ResizeObserver !== 'undefined') {
        new ResizeObserver(state.update).observe(slider);
      }

      requestAnimationFrame(function () {
        state.update();
        container.classList.add('recs-inline--initialized');
      });
    }

    if (state.flkty && state.flkty !== flkty) {
      state.flkty.off('scroll', state.onScroll);
      state.flkty.off('select', state.onScroll);
      state.flkty.off('settle', state.onScroll);
    }

    state.flkty = flkty;
    flkty.on('scroll', state.onScroll);
    flkty.on('select', state.onScroll);
    flkty.on('settle', state.onScroll);
    state.update();

    return state.update;
  }

  function initOne(section) {
    if (!section || section.dataset.fcbsInit === 'true') return;
    var slider = section.querySelector('[data-fcbs-slider]');
    if (!slider) return;
    if (typeof Flickity === 'undefined') return;

    section.dataset.fcbsInit = 'true';

    var nav = slider.dataset.showNav === 'true';
    var totalSlides = slider.querySelectorAll('.carousel-cell').length;
    var updateScrollbar = null;

    function getOptions() {
      var slidesToShow = getGroupCells(slider);
      var containV = totalSlides <= slidesToShow;
      var wrapV = totalSlides > slidesToShow;
      var trueNav = Boolean(nav && wrapV);
      return {
        cellAlign: 'left',
        contain: containV,
        imagesLoaded: true,
        wrapAround: wrapV,
        autoPlay: false,
        prevNextButtons: trueNav,
        pageDots: false,
        draggable: wrapV,
        touchVerticalScroll: false,
        adaptiveHeight: false,
        percentPosition: true,
      };
    }

    var flkty = new Flickity(slider, getOptions());
    var lastSlidesToShow = getGroupCells(slider);
    updateScrollbar = bindScrollbar(section, slider, flkty);

    function onResize() {
      var newSlides = getGroupCells(slider);
      if (newSlides !== lastSlidesToShow) {
        flkty.destroy();
        flkty = new Flickity(slider, getOptions());
        lastSlidesToShow = newSlides;
        updateScrollbar = bindScrollbar(section, slider, flkty);
      } else {
        flkty.resize();
        if (updateScrollbar) updateScrollbar();
      }
    }

    var debounced =
      typeof theme !== 'undefined' &&
      theme.utils &&
      typeof theme.utils.debounce === 'function'
        ? theme.utils.debounce(300, onResize)
        : (function () {
            var t;
            return function () {
              clearTimeout(t);
              t = setTimeout(onResize, 300);
            };
          })();

    window.addEventListener('resize', debounced);

    // If theme code already initialized Flickity on this node, prefer that instance.
    // (Defensive: Shopify editor can re-render.)
    var existing = getFlkty(slider);
    if (existing && existing !== flkty) {
      try {
        flkty.destroy();
      } catch (e) {}
    }
  }

  function boot() {
    document
      .querySelectorAll('[data-section-type="featured-collection-banner-slider"]')
      .forEach(initOne);
  }

  function onSectionLoad(e) {
    if (!e.target || !e.target.querySelectorAll) return;
    e.target
      .querySelectorAll('[data-section-type="featured-collection-banner-slider"]')
      .forEach(initOne);
  }

  if (!window.__fcbsListeners) {
    window.__fcbsListeners = true;
    document.addEventListener('page:loaded', boot);
    document.addEventListener('shopify:section:load', onSectionLoad);
  }

  if (typeof Flickity !== 'undefined') {
    boot();
  } else {
    document.addEventListener('DOMContentLoaded', boot);
  }
})();

